<template>
  <svg class="pictoAlert" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19" height="24" viewBox="0 0 19 24"><defs><clipPath id="a"><rect width="19" height="24" fill="rgba(0,0,0,0)" stroke-width="1"/></clipPath></defs><g clip-path="url(#a)"><path d="M17.713,15.4c-2.308-.66-2.759-4.407-3.213-9.9-.247-2.99-2-5-5-5s-4.753,2.01-5,5c-.454,5.489-.9,9.236-3.213,9.9A1.031,1.031,0,0,0,.5,16.37V18.5a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1V16.37A1.031,1.031,0,0,0,17.713,15.4Z" fill="rgba(0,0,0,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/><path d="M11.5,21.5a2,2,0,0,1-4,0" fill="rgba(0,0,0,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></g></svg>
</template>

<script>

export default {
  name: 'PictoAlert'
}
</script>
